/* eslint-disable react-hooks/exhaustive-deps */
import Separator from "@/app/components/lib/Separator";
import { useTranslation } from "@/hooks/localization/useTranslations";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import BundleItem from "./bundle-item/BundleItem";
import { IBundleItem } from "@/api/AppApi/services/product/interfaces/product-bundle-types";
import { generateBundleItems } from "./functions";
import { ISelectedBundleItems } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";

const BundleItems: React.FC<{
  items: IBundleItem[];
  setSelectedBundleItems: Dispatch<SetStateAction<ISelectedBundleItems[]>>;
  selectedBundleItems: ISelectedBundleItems[];
}> = ({ items, setSelectedBundleItems, selectedBundleItems }) => {
  const t = useTranslation();
  // Process all items : Repeats items for configurable products
  const processedItems = items.flatMap(generateBundleItems);

  useEffect(() => {
    if (!items.length) return;
    const initSelectedItems: ISelectedBundleItems[] = processedItems.map(
      (item) => ({
        bundle_item_id: item.id,
        product_id: item.product_id,
        is_configurable: item.product.is_configurable,
        child: null,
      }),
    );
    setSelectedBundleItems(initSelectedItems);
  }, [items]);

  const hanldeChildChange = (item_index: number, index: number | null) => {
    setSelectedBundleItems((prev) => {
      const changedItem = prev[item_index];
      const changedItemToBut = {
        ...changedItem,
        child:
          index === null || index === -1
            ? null
            : items.find((item) => item.id === changedItem.bundle_item_id)
                ?.product?.children[index]?.id,
      };
      const Data = prev.map((item, idx) =>
        idx === item_index ? changedItemToBut : item,
      );
      return Data;
    });
  };

  if (!items || items.length < 1) return;
  return (
    <div>
      <Separator startLabel={t.items_in_this_bundle} />
      <div className="bundle-items ">
        {processedItems?.map((bundleItem, idx) => (
          <BundleItem
            setSelectedChildIndex={(childIndex) =>
              hanldeChildChange(idx, childIndex)
            }
            key={`${bundleItem?.id} ${bundleItem?.product_id} ${idx}`}
            {...bundleItem}
            selectedChildId={selectedBundleItems[idx]?.child}
          />
        ))}
      </div>
    </div>
  );
};

export default BundleItems;
